import {
  formatAbsenceHalfDayPart,
  getAbsenceTypeLabel,
  isHalfDayAbsence,
} from "@/lib/employeeAbsences";
import type { PlanungAbsence } from "@/lib/montageplanung";
import { formatDateDe } from "./dateUtils";

export function findAbsenceConflicts(
  absences: PlanungAbsence[],
  dateFrom: string,
  dateTo: string,
): PlanungAbsence[] {
  const from = dateFrom.slice(0, 10);
  const to = dateTo.slice(0, 10);
  return absences.filter(
    (a) => a.date_from.slice(0, 10) <= to && a.date_to.slice(0, 10) >= from,
  );
}

function formatConflictRange(absence: PlanungAbsence): string {
  const from = formatDateDe(absence.date_from);
  const to = formatDateDe(absence.date_to);
  if (from === to && isHalfDayAbsence(absence)) {
    return `${from} ${formatAbsenceHalfDayPart(absence.half_day_part, "long")}`;
  }
  return `${from}–${to}`;
}

export function formatAbsenceConflictMessage(
  conflicts: PlanungAbsence[],
  rowLabel: string,
): string {
  const details = conflicts
    .map((c) => `${getAbsenceTypeLabel(c.absence_type)} (${formatConflictRange(c)})`)
    .join(", ");
  return `Für ${rowLabel} ist in diesem Zeitraum eine Abwesenheit hinterlegt: ${details}.`;
}
